module.exports = __webpack_public_path__ + "img/hint-one-mobile.f913ff6b.png";